import { parseHTMLToPlainText } from '@/utils/parseHTMLToPlainText'

export const MAX_TEXT_MESSAGE_LENGTH = 160
export const LENGTH_MIN_COLOR = [0, 0, 0, 0.54]
export const LENGTH_MAX_COLOR = [200, 30, 30, 1]

const clock = (min: number, max: number, ratio: number) => {
  return min + (max - min) * ratio
}

export const getTextWithoutVariables = (text: string) => {
  const modifiedText = text.replace(/\{\{.*?\}\}/g, '-')
  return parseHTMLToPlainText(modifiedText)
}

export const textMessageLengthColor = (count: number) => {
  const ratio = count / MAX_TEXT_MESSAGE_LENGTH

  return `rgba(${clock(
    LENGTH_MIN_COLOR[0],
    LENGTH_MAX_COLOR[0],
    ratio
  )}, ${clock(LENGTH_MIN_COLOR[1], LENGTH_MAX_COLOR[1], ratio)}, ${clock(
    LENGTH_MIN_COLOR[2],
    LENGTH_MAX_COLOR[2],
    ratio
  )}, ${clock(LENGTH_MIN_COLOR[3], LENGTH_MAX_COLOR[3], ratio)})`
}

export const REMINDER_DAY_OPTIONS = [
  { label: 'Never', value: '0' },
  { label: '1 day', value: '1' },
  { label: '2 days', value: '2' },
  { label: '3 days', value: '3' },
  { label: '4 days', value: '4' },
  { label: '5 days', value: '5' },
  { label: '6 days', value: '6' },
  { label: '7 days', value: '7' },
  { label: '2 weeks', value: '14' },
]
